import proyecto from "../../api/Proyecto";
import { getSelectedCajaId } from "../../helpers/cajaSelection";

export const registrarAbono = async (abono) => {
  const res = await proyecto.post("/abonos", { ...abono, id_caja: getSelectedCajaId() });
  return res.data;
};
